import React, {useState, useEffect} from 'react'
import {Navigate} from 'react-router-dom'
import CalendarHistorique from './Graphiques/Calendar-historique'
import FooterNavMildiou from './MEP/footer-nav-mildiou'
import EnteteMildiou from './MEP/enete-milidou'

function HistoriqueAlerte() {
    const [annee, setannee] = React.useState("2020")
    const [data, setdata] = React.useState()
    const [goToPDL, setgoToPDL] = useState(false)
    function handleClick(){
      setgoToPDL(true)
    }

    useEffect ( () => {
      fetch("https://api2050.diagorisk.com/mildiou/historiqueAlerte/?idParcelle=1&annee=" + annee)
      .then( (response) => {
          return response.json()
      })
      .then(response =>{
        setdata(response[0])
        setdata(prev => {
        return prev;
      })
      }) 
        
    }, [])

  function handleChange(event){
    let anneeValue = event.target.value
    setannee(anneeValue)
    fetch("https://api2050.diagorisk.com/mildiou/historiqueAlerte/?idParcelle=1&annee=" + anneeValue)
    .then( (response) => {
        return response.json()
    })
    .then(response =>{
        setdata(response[0])
        setdata(prev => {
        return prev;
    })
    }) 
  }
  
  if(goToPDL) {
    return <Navigate push to={`/diagoriskMildiou/menu-plan-de-lutte`}/>
  }
  return (
    <div>
      <EnteteMildiou titre={'Historique Alerte'}/>
      <FooterNavMildiou/>
      <div className='containerMildiou'> 
        <div style={{marginBottom:'20px'}}><button className='titreMoins colorPrincipal' onClick={handleClick} style={{backgroundColor: 'transparent', border: 'none'}} > {'<'} Revenir </button></div>
        <label className='titreMoins colorPrincipal'>Choisissez une année : </label>
        <div style={{width:'100%'}}><select id="yearSelect" value={annee} onChange={handleChange} className='selectAnneeMildiou'>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
        </select></div>
        {data !== undefined ?
          <CalendarHistorique data={data}/>
        : "" }
      </div>
    </div>
  )
}

export default HistoriqueAlerte